import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import './ChatButtons.css';
import Button from 'components/shared/button/Button';
import Dropzone from 'react-dropzone';
import ImageUpload from 'components/shared/image-upload/ImageUpload';
import DocumentLink from 'components/shared/document/DocumentLink';
import uploadSvg from 'images/upload.svg';
import removeIconPng from 'images/remove.png';
import { imageExtensions } from 'services/utils/files-util';
import {
  setImages,
  removeImage,
  getImages,
  setDocuments,
  removeDocument,
} from 'services/utils/attachments-util';

export default function ChatButtons(props) {
  const { newNote, handleFormChange, handleSubmit } = props;

  return (
    <div className="chat-buttons">
      <Row className="notes-buttons">
        <Col sm={6} className="doc-row">
          <Dropzone
            accept="application/pdf, .doc, .docx, .xls, .xlsx"
            className="dropzone-container"
            onDrop={(files) => setDocuments(files, newNote, handleFormChange)}
          >
            <span>Please drag and drop any file into this area</span>
            <img src={uploadSvg} alt="upload" />
          </Dropzone>
          {newNote.documents &&
            newNote.documents.map((doc, index) => {
              return (
                <div className="doc-viewer" key={index}>
                  <img
                    className="remove-doc-icon"
                    src={removeIconPng}
                    alt="remove"
                    onClick={() =>
                      removeDocument(index, newNote, handleFormChange)
                    }
                  />
                  <DocumentLink file={doc} url={doc.url} />
                </div>
              );
            })}
        </Col>
        <Col sm={6}>
          <ImageUpload
            extensions={imageExtensions}
            multiple
            onUpload={(files) => setImages(files, newNote, handleFormChange)}
            onRemove={(index) => removeImage(index, newNote, handleFormChange)}
            images={getImages(newNote)}
          />
        </Col>
      </Row>
      <Button className="button-orange" label="Send" onClick={handleSubmit} />
    </div>
  );
}

ChatButtons.propTypes = {
  newNote: PropTypes.shape(),
  handleFormChange: PropTypes.func,
  handleSubmit: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/shared/chat/ChatButtons.js